import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  mealById, meals, updateMealStatus,
} from '../../axios/resturantsMenuRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IMenu, IMenuStore,
} from '../storeInterfaces/menuCategoryInterface';
import { RequestStatus } from 'mobx-store';

export class MenuStore implements IMenuStore {
  @observable menuList: any[] = [];

  @observable selectedMenu = {
  };

  @observable loading = false;

  @observable getMenuCategoriesRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getMenus(categoryId: number, countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      this.getMenuCategoriesRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'all',
      };
      const response = await Connections.wadiDeglaAxios.httpGet(meals(categoryId), {
        ...getHeader(langCode), params,
      });
      this.menuList = this.restructureMenuList(response.data);
      this.getMenuCategoriesRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getMenuCategoriesRequestStatus = RequestStatus.FAILED;
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getMenuById(id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(mealById(id), getHeader(langCode));
      this.selectedMenu = this.restructureMenu(response.data);
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createMenu(categoryId: number, newMenu: any, langCode: string = DefaultLanguage): Promise<any> {
    return new Promise<void>(async (res, rej) => {
      try {
        newMenu.images = await this.uploadImages(newMenu.images);
        newMenu.thumbnail = (await this.uploadImages(newMenu.thumbnail))[0];
        const response = await Connections.wadiDeglaAxios.httpPost(meals(categoryId), this.restructureUpdatedOrCreatedMenu(newMenu), getHeader(langCode));
        res(response.restaurantCategoryMealId);
      } catch (error) {
        rej(error);
      }
    });
  }

  @action.bound
  public async updateMenu(updatedMeal: any, id: number, langCode: string = DefaultLanguage): Promise<any> {
    try {
      updatedMeal.images = await this.uploadImages(updatedMeal.images);
      updatedMeal.thumbnail = (await this.uploadImages(updatedMeal.thumbnail))[0];
      await Connections.wadiDeglaAxios.httpPut(mealById(id), this.restructureUpdatedOrCreatedMenu(updatedMeal), getHeader(langCode));
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updateMenuStatus(updatedMenuStatus: boolean, index: number): Promise<any> {
    try {
      await Connections.wadiDeglaAxios.httpPut(updateMealStatus(this.menuList[index].mealId),
        {
          isActive: updatedMenuStatus,
        });
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.menuList[index].isActive = updatedMenuStatus;
    }
  }

  private restructureMenuList(menus: any[]): any[] {
    const menusList = [];
    for (const meal of menus) {
      menusList.push({
        mealId: meal.restaurantCategoryMealId,
        images: this.formatMealImages(meal.mealImages),
        titleAr: meal.name,
        titleEn: meal.name,
        isActive: meal.isActive,
        price: meal.price,
      });
    }
    return menusList;
  }

  private restructureMenu(meal: any): IMenu {
    return {
      mealId: meal.restaurantCategoryMealId,
      images: this.formatMealImages(meal.mealImages),
      title: meal.name,
      isActive: meal.isActive,
      price: meal.price,
      description: meal.description,
      thumbnail: this.formatMealImages([
        {
          imageURL: meal?.thumbnail,
          isTemp: false,
        }
      ]),
    };
  }
  private formatMealImages (images: {imageURL: string, isTemp: boolean} []) {
    console.log("images", images)
    if(!images || !images?.length) {
      return [];
    }
    const mapped = images.map(img => {
      return {
        imageUrl: img.imageURL
      }
    });
    return mapped;
  }
  private uploadImages(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push(res.data.downloadURL);
            }),
        );
      } else {
        allImages.push(image.imageUrl);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return (allImages.length ? allImages : []);
      }).catch((error) => {
        console.log('error');
        return (allImages.length ? allImages : []);
      });
  }

  private restructureUpdatedOrCreatedMenu(menu: IMenu): any {
    return {
      name: menu.title,
      images: menu.images,
      price: menu.price,
      description: menu.description,
      availableCountries: menu.availableCountries,
      thumbnail: menu.thumbnail,
    };
  }
}
